module.exports = __webpack_public_path__ + "img/weixin.44ac3cf2.png";